module.exports = __webpack_public_path__ + "assets/images/profiles/1970-3-desktop.jpg?v=dc6106f3";